import { Leaf } from './components/Leaf';
import { Element } from './components/Element';
import { RenderElementProps, RenderLeafProps } from 'slate-react';
import { CustomEditor } from 'slate/types/slate';

const withDefaultRenderers = (editor: CustomEditor) => {
  editor.renderElement = (props: RenderElementProps) => <Element {...props} />;
  editor.renderLeaf = (props: RenderLeafProps) => <Leaf {...props} showFormatting={editor.showFormatting} />;
  return editor;
};

export default withDefaultRenderers;
